import { usePageState } from "../context/usePageState";
import { RecordDefinition } from "./recordDefinition.types";

/** Whether the user may open this page, and whether they may change its record. */
export function useEntityPagePermissions(definition: RecordDefinition | undefined) {
  // Not a fetchRecord dependency: its identity changes on every page context render.
  const { hasAnyRole } = usePageState();

  // A boolean, not the function, so it's stable enough to be a fetch dependency.
  const allowedRoles = definition?.allowedRoles;
  const isAllowed = !allowedRoles || hasAnyRole(allowedRoles);
  const recordEditRoles = definition?.recordEditRoles;
  const canEdit = !recordEditRoles || hasAnyRole(recordEditRoles);

  return { isAllowed, canEdit };
}
